import { BASIC_TUTORIAL } from "./basic.js";
import { CHARACTER_EDITOR_MANUAL } from "./character-editor.js";
import { DEBUGGER_MANUAL } from "./debugger.js";
import { FORTH_TUTORIAL } from "./forth.js";
import { IMAGE_EDITOR_MANUAL } from "./image-editor.js";
import { SPRITE_EDITOR_MANUAL } from "./sprite-editor.js";
import { TILE_MAP_EDITOR_MANUAL } from "./tile-map-editor.js";
import { TRACKER_MANUAL } from "./tracker.js";
import type { UserManual } from "./types.js";

export const USER_MANUALS: UserManual[] = [
  TRACKER_MANUAL,
  SPRITE_EDITOR_MANUAL,
  CHARACTER_EDITOR_MANUAL,
  TILE_MAP_EDITOR_MANUAL,
  IMAGE_EDITOR_MANUAL,
  DEBUGGER_MANUAL,
  BASIC_TUTORIAL,
  FORTH_TUTORIAL
];
